import { computed, ref } from 'vue'
import { defineStore } from 'pinia'
/** @typedef {import('vue').Ref<import('../types/menu').MenuTypes>} Menu */

export const useMenuStore = defineStore('menu', () => {
  /** @type {Menu} */
  const menu = ref({})
  const loading = ref({ menu: true })

  const categorias = computed(() => menu.value?.categoria_set)

  return {
    menu,
    loading,
    categorias,
  }
})
